import routes from "./routes.json";

export const SITE = {
  name: "Primed Landscaping",
  origin: "https://www.primedlandscaping.com",
  language: "en-US",
  email: "primedlandscaping@gmail.com",
  phone: "+12062587535",
  displayPhone: "(206) 258-7535",
  areaServed: "Maple Valley and the Greater Seattle area, Washington",
  defaultImage: "/resd1.jpeg",
  organizationId: "https://www.primedlandscaping.com/#organization",
  websiteId: "https://www.primedlandscaping.com/#website",
};

export const STATIC_ROUTES = routes;
export const absoluteUrl = (value = "/") => /^https?:\/\//i.test(value)
  ? value
  : `${SITE.origin}${value.startsWith("/") ? value : `/${value}`}`;
export const getRouteSeo = (pathname) => STATIC_ROUTES.find((route) => route.path === pathname) || null;
